'use strict';

exports.__esModule = true;
exports.widget = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _widgetActions = require('../actions/widget-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NOT_FOUND_CODE = 404;
var FORBIDDEN_CODE = 403;
var SERVER_ERROR = 500;

var INITIAL_STATE = {
	login: {
		error: false,
		email: '',
		rememberMe: false,
		submitAttempted: false,
		submitFailed: false,
		validEmail: false
	}
};
var setRelevantErrorMessage = function setRelevantErrorMessage(error) {
	switch (error.code) {
		case FORBIDDEN_CODE:
			return 'The service that redirected you here does not have permissions to get your user details.';
		case SERVER_ERROR:
			return 'There was a Server error.';
		default:
			return 'There was Server error';
	}
};
var widget = exports.widget = function widget(state, action) {
	switch (action.type) {
		case _widgetActions.LOGIN_EMAIL_CHANGE:
			return (0, _extends3.default)({}, state, { email: action.email });
		case _widgetActions.LOGIN_SET_VALID_EMAIL:
			return (0, _extends3.default)({}, state, {
				validEmail: action.valid
			});
		case _widgetActions.LOGIN_VALIDATION_FAILED:
			return (0, _extends3.default)({}, state, {
				submitAttempted: true,
				submitFailed: true
			});
		case _widgetActions.LOGIN + '_REQUESTED':
			return (0, _extends3.default)({}, state, {
				error: false,
				serverError: false,
				submitAttempted: false,
				submitFailed: false
			});
		case _widgetActions.LOGIN + '_RECEIVED':
			return (0, _extends3.default)({}, state, {
				redirect: true,
				token: action.response.token
			});
		case _widgetActions.LOGIN + '_FAILED':
			return (0, _extends3.default)({}, state, {
				submitAttempted: true,
				submitFailed: true,
				error: typeof action.errorData === 'string' || action.errorData && action.errorData.code === NOT_FOUND_CODE,
				serverError: typeof action.errorData !== 'string' && action.errorData.code !== NOT_FOUND_CODE && setRelevantErrorMessage(action.errorData)
			});
		default:
			return state || INITIAL_STATE;
	}
};